import React from "react";
import { Check, AlertTriangle } from "lucide-react";

const ImportantInstructionsCard = ({ onClose }) => {
  // مصفوفة التعليمات - تصغير الخط وتنسيق الكلام بالعامية المحترمة
  const instructions = [
    { 
      text: "1- لما بتعمل حسابك، ياريت تتأكد إن بياناتك كلها صح (اسمك رباعي، رقم الواتساب بتاعك، ورقم ولي أمرك)." 
    },
    { 
      text: "2- احفظ الباسورد (كلمة السر) بتاعتك كويس ومتنساهاش عشان دي بوابتك للدخول." 
    },
    { 
      text: "3- كل فيديو على المنصة بتقدر تفتحه 5 مرات بس، عشان كدا اتأكد إن النت عندك كويس ومستقر قبل ما تفتح الفيديو." 
    },
    { 
      text: "4- التزم بمشاهدة الفيديوهات، وحل الواجبات، والامتحانات في وقتها؛ دي مسؤوليتك تجاه مستقبلك." 
    },
    { 
      text: "5- إحنا بنبعت تقرير دوري عن مستواك لولي أمرك، عشان يكون متابع تطورك ومجهودك معانا." 
    },
    { 
      text: "6- للأسف، أي طالب غير ملتزم في المنصة مش هنقدر نكمل معاه الاشتراك، عشان نحافظ على مستوى الجميع." 
    },
    { 
      text: "7- مشاهدة الفيديو بتتحسب لو اتفرجت على أكتر من 30% من مدته، فتأكد إنك كملت الجزء المطلوب." 
    },
    { 
      text: "8- الاشتراك بيكون في امتحانات الدور الأول، وفي إمكانية استرجاع سعر الكورس لو ملتزم بالقواعد." 
    },
  ];

  return (
    <div className="w-full flex justify-center py-10 px-4">
      {/* الكارت الأساسي - خلفية شفافة وتأثير الزجاج (Glassmorphism) */}
      <div 
        className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-lg shadow-2xl rounded-3xl max-w-3xl w-full border border-white/20 dark:border-slate-800/50 overflow-hidden"
        dir="rtl"
      >
        {/* رأس الكارت - تصميم هادئ ومتناسق */}
        <div className="bg-blue-50/50 dark:bg-slate-800/50 border-b border-slate-100 dark:border-slate-800 p-6 md:p-8 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl -mr-10 -mt-10"></div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white dark:text-blue-400 relative z-10 flex items-center justify-center gap-3">
            <AlertTriangle className="text-White dark:text-blue-400" size={32} />
            تعليمات هامة
          </h2>
          <p className="text-slate-500 dark:text-slate-400 mt-2 font-medium">
            ياريت تقرأ التعليمات دي كويس عشان تضمن أفضل تجربة تعليمية على المنصة
          </p>
        </div>

        {/* جسم الكارت - تصغير الخط لـ text-sm */}
        <div className="p-6 md:p-8">
          <ul className="space-y-3">
            {instructions.map((item, index) => {
              return (
                <li 
                  key={index} 
                  className="flex items-start gap-3 p-4 rounded-2xl hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors duration-300 border border-transparent hover:border-slate-100 dark:hover:border-slate-700"
                >
                  <p className="text-slate-700 dark:text-slate-300 font-semibold text-sm md:text-base leading-relaxed pt-1">
                    {item.text}
                  </p>
                </li>
              );
            })}
          </ul>
        </div>

        {/* ذيل الكارت والزرار في النص */}
        <div className="p-6 md:p-8 pt-0 flex justify-center mt-4">
          <button
            onClick={onClose}
            className="group relative flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3.5 px-12 rounded-2xl text-lg font-bold shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 transform hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto min-w-[250px]"
          >
            <span>قرأت التعليمات وموافق</span>
            <Check size={24} className="group-hover:scale-110 transition-transform" />
          </button>
        </div>

      </div>
    </div>
  );
};

export default ImportantInstructionsCard;